var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button",class:_vm.disabled ? 'secondary' : _vm.buttonClass,on:{"click":_vm.onClick}},[_c('div',{staticClass:"text",class:_vm.disabled ? 'secondary-text' : _vm.textClass},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }